import { API_URL } from 'core/infra/environment'
import { HttpClient, type HttpClientConfig } from 'core/infra/http/HttpClient'

import { type PreferredTrackingMethod } from '../domain/PreferredTrackingMethod'
import { CarrierRepository } from '../infra/CarrierRepository'

export function updatePreferredTrackingMethod(
  preferredTrackingMethod: PreferredTrackingMethod,
  config?: Partial<HttpClientConfig>
) {
  const httpClient = new HttpClient(API_URL)
  const repository = new CarrierRepository({ httpClient })

  return repository.updatePreferredTrackingMethod(preferredTrackingMethod, config)
}
